module.exports = function(ads) {
	'use strict'
	ads.directive('adItem',adItem);
	adItem.$inject=["checkArray","keyPressOnlyNumberAndDot",'$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService','jQuery'];
	function adItem(checkArray,keyPressOnlyNumberAndDot,$timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, jQuery) {
		return {
			restrict: 'E',
			scope:{
				ad:'=',
                categories:'='
			},
			replace:true,
			template: require('./partial/adItem.html'),
			link: function(scope, ele, $attrs, ctrl) {
				scope.selectedCategory = {value:'default'};
                scope.checkedItems = [];
                scope.categoriesCopy = angular.copy(scope.categories)
                scope.keyPressOnlyNumberAndDot = keyPressOnlyNumberAndDot;
                scope.addPostIdHandler = function (postId) {
                    if(!postId) {
                        scope.postIdRequired = true 
                    } else {
                        scope.postIdRequired = false;
                        if(!checkArray.contains.call(scope.ad.post_ids,postId)) {
                            scope.ad.post_ids.push(postId);
                            scope.addPostId = null;
                            scope.existPostId = false;
                        } else {
                            scope.existPostId = true;
                        }
                    }
                }
                scope.removeFromPostList = function(index) {
                    scope.ad.post_ids.splice(index, 1);
                }
                function checkArrayItems(children, boll){
                    children.forEach(function(item){
                        if(item.children && item.children.length>0) {
                            checkArrayItems(item.children, boll)
                        }
                        item.open = false;
                        if(!item.disabled) {
                            item.checked = boll;
                        }
                    })

                }
                scope.switchCategories = function(categoryId) {
                    if(categoryId=='default') return
                    if(categoryId == 'all') {
                        scope.checkedItems = []
                        scope.categoriesCopy.filter(function(item){
                            return item._id != 'uncategorized'
                        }).map(function(item){
                            if(item.children && item.children.length>0) {
                                checkArrayItems(item.children, true)
                            }
                            if(!item.disabled) {
                                item.checked = true;
                            }
                            item.open = false;
                            scope.checkedItems.push(item)
                            return item.selected = true
                        })    
                    } else if(categoryId == 'none') {
                        scope.categoriesCopy.map(function(item){
                            if(item.children && item.children.length>0) {
                                checkArrayItems(item.children, false)
                            }
                            if(!item.disabled) {
                                item.checked = false;
                            }
                            scope.checkedItems = [];
                            return item.selected = false
                        })
                    } else {
                        scope.categoriesCopy.map(function(item){
                            if(item._id ==categoryId){
                                if(item.children && item.children.length>0) {
                                    checkArrayItems(item.children, true)
                                }
                                item.open = false;
                                if(!item.disabled) {
                                    item.checked = true;
                                }
                                scope.checkedItems.push(item)
                                return item.selected = true
                            }
                        })
                    }
                    scope.selectedCategory = {value:'default'};
                }
                scope.removeItem = function(itemId) {
                    scope.checkedItems.splice(scope.checkedItems.findIndex(function(item){
                        return item._id == itemId
                    }), 1);
                    scope.categoriesCopy.map(function(item) {
                    if(item._id==itemId) {
                        if(item.children && item.children.length>0) {
                            checkArrayItems(item.children, false)
                        }
                        item.open = false;
                        return item.selected = false
                    }
                    })
                }
                function populateAdItemsChecked(children,adItem, firstAncestors) {
                    children.forEach(function(item){
                        if(item._id == adItem) {
                            item.checked = true;
                            if(!firstAncestors.selected) {
                                firstAncestors.selected = true
                            }
                        } else {
                            if(item.children && item.children.length>0) {
                                populateAdItemsChecked(item.children, adItem, firstAncestors)
                            }
                        }
                    })
        
                }
                function populateAdItems(items) {
                    scope.categoriesCopy.forEach(function(category) {
                        items.forEach(function(item){
                            if(item == category._id) {
                                category.checked = true;
                                category.selected = true;
                            } else {
                                if(category.children && category.children.length>0) {
                                    populateAdItemsChecked(category.children, item, category)
                                }
                            }
                        })
                        if(category.selected) {
                            scope.checkedItems.push(category)
                        }
                    })
                }
                if(scope.ad.items && scope.ad.items.length>0) {
                    populateAdItems(scope.ad.items)
                }
                if(!scope.ad.post_ids) {
                    scope.ad.post_ids = []
                }
                scope.ad.getItems = function() {
                    var checkedId = []
                    function pushToSaveAdItems(children) {
                        children.forEach(function(item){
                            if(item.checked) {
                                checkedId.push(item._id) 
                            }
                            if(item.children && item.children.length>0) {
                                pushToSaveAdItems(item.children)
                            }
                        })
                    }
                    scope.checkedItems.forEach(function(item){
                        if(item.checked) {
                            checkedId.push(item._id)
                        }
                        if(item.children && item.children.length>0) {
                            pushToSaveAdItems(item.children)
                        }
                    })
                    return checkedId
                }
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/adsModule/settings/js/directive/adItemDirective.js
// module id = 482
// module chunks = 0